import { ButtonText } from "components/Atoms/Button";
import { FilterProvider, FilterProviderRef, FilterValues } from "components/filters/FilterContext";
import FilterHeader from "components/filters/FilterHeader";
import NotificationStatusFilter from "components/filters/Filters/NotificationStatusFilter";
import { appendFilterValuesToQueryString } from "components/filters/mappingUtils";
import Panel from "components/panels/panel";
import React, { useRef, useState } from "react";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import NotificationList, { NotificationListRef } from "./NotificationList";
import { useLoaderData } from "react-router";

interface NotificationListTemplateProps {
  filterSet: server.dto.FilterSets;
  perPage?: number;
  defaultFilters: server.dto.ListNotificationFilters;
  initialInstruction: server.dto.ListNotificationInstruction;
}

export const NotificationListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.NotificationListFrontModel>();

  return <NotificationListTemplate
    filterSet="notification_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
  />
}

const NotificationListTemplate = (props: NotificationListTemplateProps) => {
  const {
    filterSet,
    perPage = 30,
    defaultFilters,
    initialInstruction,
  } = props;
  const filterRef = useRef<FilterProviderRef>(null);
  const notificationListRef = useRef<NotificationListRef>(null);

  const initInstruction = (instruction: server.dto.ListNotificationInstruction) => ({
    ...instruction,
    page: 1,
    perPage,
    cache: filterSet,
  });

  const [instruction, onInstructionChange] = useState<server.dto.ListNotificationInstruction>(initInstruction(initialInstruction));
  const [initialLoading, setInitialLoading] = useState(true);

  const onLoad = (filters: server.dto.ListNotificationFilters) => {
    if (initialLoading) {
      filterRef.current.setDefaultValues((prev: FilterValues) => {
        return mapResponseToFilterValues(defaultFilters, prev);
      });
    }
    const filtersWithValues = filterRef.current.updateValues((prev: FilterValues) => {
      return mapResponseToFilterValues(filters, prev);
    });
    if (initialLoading) {
      appendFilterValuesToQueryString(filtersWithValues);
    }
    setInitialLoading(false);
  }

  const onFilterChange = (filter: FilterValues, filtersWithValues: Partial<FilterValues>) => {
    const newInstruction = mapFilterValuesToInstruction(filterSet, filter, 1, perPage);
    appendFilterValuesToQueryString(filtersWithValues);
    onInstructionChange(newInstruction);
  }

  return <Panel
    headerContainerClasses="top-navigation-wrapper"
    contentCssClass="flex-column panel-gap"
  >
    <FilterProvider
      ref={filterRef}
      onFilterChange={onFilterChange}
    >
      <div className="flex panel-gap">
        <FilterHeader.Filters isLoading={initialLoading}>
          <div className="selectiontool-header-filters">
            <NotificationStatusFilter />
          </div>

          <div className="selectiontool-header-button">
            <ButtonText
              label={RESX.Notifications.MarkAllAsRead}
              onClick={() => { notificationListRef.current?.markAllAsRead() }}
            />
          </div>
        </FilterHeader.Filters>
      </div>

      <div className="s1_panel">
        <NotificationList
          ref={notificationListRef}
          for="list"
          status={instruction.notificationStatus}
          onLoad={onLoad}
        />
      </div>
    </FilterProvider>
  </Panel>
}